import { nodeFromHtml } from '@/utility/functions';

const Alert = function(html, appendTo, options = {}) {
  const config = Object.assign({
    autoDestroy: true,
    prepend: false,
  }, options);

  const detectClick = (event) => {
    if(!event.target.hasAttribute('data-alert-trigger-close')) {
      return;
    }

    this.destroy();
  };

  this.destroy = () => {
    clearTimeout(timeout);

    if(alertEl === null) {
      return;
    }

    alertEl.parentNode.removeChild(alertEl);

    document.removeEventListener('click', detectClick);

    alertEl = null;
  }

  let alertEl = nodeFromHtml(html);
  let timeout;

  let target = document.getElementById(appendTo ?? 'toast-portal');

  if(config.prepend) {
    target.prepend(alertEl);
  } else {
    target.appendChild(alertEl);
  }
  document.addEventListener('click', detectClick);

  if(config.autoDestroy) {
    timeout = setTimeout(this.destroy, 3000);
  }

  return this;
};

export default Alert;
